 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTML00_TITLE_PA from '@/components/html/00_Title_Pa'
 import HTML01_COPYRIGH from '@/components/html/01_Copyrigh'
 import HTML02_ACKNOWLE from '@/components/html/02_Acknowle'
 import HTML03_CONTENTS from '@/components/html/03_Contents'
 import HTML04_LIST_OF from '@/components/html/04_List_of'
 import HTML05_LIST_OF from '@/components/html/05_List_of'
 import HTML06_INTRODUC from '@/components/html/06_Introduc'
 import HTML07_CHAPTER from '@/components/html/07_Chapter'
 import HTML08_RECOGNIZ from '@/components/html/08_Recogniz'
 import HTML09_CHAPTER from '@/components/html/09_Chapter'
 import HTML10_OVERVIEW from '@/components/html/10_Overview'
 import HTML11_CHAPTER from '@/components/html/11_Chapter'
 import HTML12_ISA_95 from '@/components/html/12_ISA_95'
 import HTML13_CHAPTER from '@/components/html/13_Chapter'
 import HTML14_INTRODUC from '@/components/html/14_Introduc'
 import HTML15_CHAPTER from '@/components/html/15_Chapter'
 import HTML16_SCOPE_OF from '@/components/html/16_Scope_of'
 import HTML17_CHAPTER from '@/components/html/17_Chapter'
 import HTML18_INTRODUC from '@/components/html/18_Introduc'
 import HTML19_CHAPTER from '@/components/html/19_Chapter'
 import HTML20_OVERVIEW from '@/components/html/20_Overview'
 import HTML21_CHAPTER from '@/components/html/21_Chapter'
 import HTML22_EXECUTIV from '@/components/html/22_Executiv'
 import HTML23_CHAPTER from '@/components/html/23_Chapter'
 import HTML24_INTRODUC from '@/components/html/24_Introduc'
 import HTML25_APPENDIX from '@/components/html/25_Appendix'
 import HTML26_APPENDIX from '@/components/html/26_Appendix'
 import HTML27_APPENDIX from '@/components/html/27_Appendix'
 import HTML28_INDEX from '@/components/html/28_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/03_Contents",
 			"name" : "html/03_Contents",
 			"component" : HTML03_CONTENTS
 		},
 		{
 			"path" : "/html/04_List_of",
 			"name" : "html/04_List_of",
 			"component" : HTML04_LIST_OF
 		},
 		{
 			"path" : "/html/05_List_of",
 			"name" : "html/05_List_of",
 			"component" : HTML05_LIST_OF
 		},
 		{
 			"path" : "/html/06_Introduc",
 			"name" : "html/06_Introduc",
 			"component" : HTML06_INTRODUC
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js